var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoyalAsym01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:2.8552;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:2.2398;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;stroke:#000000;stroke-width:1.0826;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;stroke:#000000;stroke-width:1.0217;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#000000;stroke-width:1.1823;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#FFFFFF;stroke:#000000;stroke-width:1.1412;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.1,111.7c1,0.7,1,3.2,1.1,6.9c0.1,3.4-0.3,5.9-0.4,6.3c-2.2,13.5-0.6,37.5-2.9,65 c-0.2,2.4-0.7,7.8,2.1,13.6c2,4.2,4.8,6.9,6.6,8.4c-3.4,1.8-9.1,4.2-15.1,2.8c-20.6-4.8-34.7-51.3-18.9-79.9 C296.7,120.1,313.1,109.5,316.1,111.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,111.7c-1,0.7-1,3.2-1.1,6.9c-0.1,3.4,0.3,5.9,0.4,6.3c2.2,13.5,0.6,37.5,2.9,65c0.2,2.4,0.7,7.8-2.1,13.6 c-2,4.2-4.8,6.9-6.6,8.4c3.4,1.8,9.1,4.2,15.1,2.8c20.6-4.8,34.7-51.3,18.9-79.9C125.4,120.1,109,109.5,106,111.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.5,91.1c-2.8-1.1-4.2-2.6-5-3.7c-1.6-2.2-2.4-5-3.5-9.4c-0.6-2.3-0.7-3.4-1.7-4.5 c-1.3-1.6-3.2-2.2-4.6-2.4c0.2,1.4,0.4,3.7-0.1,6.4c-0.2,0.8-0.8,3.8-2.7,6.5c-2.4,3.5-5.8,4.9-10.1,6.6c-4,1.6-7.1,2.2-12.5,4.5 c-0.8,0.3-2.2,1-3.9,2.3c-0.8,0.7-2.4,2-3.5,4.2c-1.3,2.5-1.4,4.9-1.5,7.7c-0.1,1.9-0.1,2.9,0.1,3.4c2.2,4.7,20.3,0.3,22.7-0.3 c11.4-2.8,22.8-5.6,25.8-14.4C260.8,95.2,260.7,92.7,260.5,91.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.5,91.1c2.8-1.1,4.2-2.6,5.1-3.7c1.6-2.2,2.4-5,3.5-9.4c0.6-2.3,0.7-3.4,1.7-4.5c1.3-1.6,3.2-2.2,4.6-2.4 c-0.2,1.4-0.4,3.7,0.1,6.4c0.2,0.8,0.8,3.8,2.7,6.5c2.4,3.5,5.8,4.9,10.1,6.6c4,1.6,7.1,2.2,12.5,4.5c0.8,0.3,2.2,1,3.9,2.3 c0.8,0.7,2.4,2,3.5,4.2c1.3,2.5,1.4,4.9,1.5,7.7c0.1,1.9,0.1,2.9-0.1,3.4c-2.2,4.7-20.4,0.3-22.7-0.3c-11.4-2.8-22.8-5.6-25.8-14.4 C161.2,95.2,161.2,92.7,161.5,91.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.7,110.4c-4-0.8-5.8-0.7-10-2c-1.5-0.4-5.3-1.7-10-4.4c-4-2.3-9.1-5.3-12.8-11.2c-1-1.7-1.7-3.2-2.1-4.2 c-20,7.5-39.9,14.9-59.9,22.4c1.8,4.2,4.1,10.2,6,17.5c2.3,9.1,2.9,15.7,3.9,28c1.4,17.3,0.6,24.3,0.1,27.5 c-1.2,9-3.1,12.9-4.5,15.2c-3.8,6.4-9,10.1-12.2,11.9c1.9,9.7,4.2,23,5.8,38.9c0.7,6.8,3.2,32.3,2,67.8c-0.5,15.2-1.5,25.7-3.5,46 c-1.7,18-4.4,42.3-8.6,71.3c2.7,1,7,1.8,12.1,2.6c14,2,43.4,8.4,100.2,39.4c2.8-17.1,3.4-62.9,4.2-80.1c4-93.4,0.1-188.7,2.9-282.1 C208.8,112.4,204.1,111.1,200.7,110.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169,124.8c9.4-2.6,48.5-13.9,53.9-14.9c8.2-1.6,16.3-3.1,23.9-9.5c5-4.2,8-9,9.6-12.2c20,7.7,40,15.4,60,23.1 c-5.7,16.6-8.2,30.8-9.5,41.1c-1.1,9-0.9,15.3-0.5,27.9c0.1,2.2,0.5,13.2,5.1,20.9c1.4,2.4,3,4.1,3.2,4.4c3.2,3.4,6.6,5.3,8.8,6.2 c-2,9.8-4.3,23.4-6,39.8c-2.4,24-2.2,42.4-1.9,58.6c0.3,14.7,0.6,33,3.5,56.7c1.7,14.1,4.1,28.4,7.8,60.1c0.4,3.2,0.7,5.8,0.9,7.6 c-4.5,1.5-10.9,3.4-18.8,5.4c-5.8,1.4-17.1,2.7-29.9,3.8c-36.4,3.2-68.7-23.1-73.2-59.3C197,311.5,181.5,192.7,169,124.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "240.2,330.2 299.7,327.4 299.7,332.3 240.2,335.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "182.2,330.9 122.7,328.2 122.7,333.1 182.2,335.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "284.8,186.5 242.6,186.5 245.7,175.7 287.8,175.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 178.6,
    cy: 130.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.1,
    cy: 180.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.6,
    cy: 231.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 281.6,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.6,
    cy: 332,
    r: 4.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyalAsym01);
export default __webpack_public_path__ + "static/media/Royal Asym-01.4aec6d19975aceba22a2731e1dcb4a5b.svg";
export { ForwardRef as ReactComponent };